// Configuration pour l'optimisation d'images automatique
export const CONFIG = {
    debug: true,
    growth: {
        threshold: 10,          // Seuil d'agrandissement en %
        useOriginal: true,
        minConnection: '3g'
    },
    responsive: {
        densities: [1, 1.5, 2],
        sizes: { small: '100vw', medium: '50vw', large: '100vw' },
        breakpoints: { small: 480, medium: 1024 }
    },
    lazyLoading: {
        enabled: true,
        rootMargin: '200px 0px',
        threshold: 0.01,
        placeholder: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    formats: {
        autoDetect: true,
        preferredFormat: 'auto',
        checkAvif: true,
        checkWebP: true,
        pngToWebP: true
    },
    quality: { slow: 60 }
};
